(() => {
  // Koleksiyon kartlari: urunun tum fotograflari (admin sirasiyla).
  // Mobil: kaydirma + bordo cizgiler. Masaustu: uzerine gelince 2. foto + sag/sol oklar.
  // Ilk anda kartin kendi 2 fotografi kullanilir; tam liste /products/HANDLE?view=jvmedia ile
  // mobilde kart ekrana yaklasinca, masaustunde fare karta gelince alinir. Fotograflar ancak gerekince yuklenir.
  const mobile = matchMedia('(max-width: 699px)');
  const hover = matchMedia('(hover: hover) and (min-width: 700px)');
  const states = new WeakMap();
  const lists = new Map();
  const selector = '.collection product-card .product-card__media, .jv-card-gallery product-card .product-card__media';
  const keyOf = (src) => (src || '').split('?')[0].split('/').pop();
  const handleOf = (href) => (decodeURIComponent(new URL(href, location.href).pathname).match(/\/products\/([^/?#]+)/) || [])[1];

  function fetchList(handle) {
    if (!lists.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      lists.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}?view=jvmedia`)
        .then((r) => (r.ok ? r.json() : []))
        .then((items) => (Array.isArray(items) ? items.filter((i) => i && i.u) : []))
        .catch(() => []));
    }
    return lists.get(handle);
  }

  const near = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      near.unobserve(entry.target);
      states.get(entry.target)?.load();
    });
  }, { rootMargin: '300px 0px' }) : null;

  function mount(link) {
    if (!link.closest('.collection, .jv-card-gallery') || !link.closest('product-card')) return;
    if (states.has(link)) return;
    const figure = link.closest('.product-card__figure') || link.parentElement;
    const state = { index: 0, shown: 0, gesture: null, blockedUntil: 0, enabled: false, slides: [], handle: null, token: 0 };
    states.set(link, state);

    const track = document.createElement('span');
    track.className = 'jv-card-track';
    track.setAttribute('aria-hidden', 'true');

    const indicator = document.createElement('span');
    indicator.className = 'juvelore-card-indicators';
    indicator.setAttribute('aria-hidden', 'true');

    const arrows = ['prev', 'next'].map((dir) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `jv-card-arrow jv-card-arrow--${dir}`;
      button.setAttribute('aria-label', dir === 'prev' ? 'Önceki fotoğraf' : 'Sonraki fotoğraf');
      // Hizli satin al penceresindeki oklarla ayni ince ok (jv-wishlist.js arrowIcon)
      button.innerHTML = '<svg width="12" height="22" viewBox="0 0 12 22" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M11 1 1 11l10 10' : 'M1 1l10 10L1 21') + '"/></svg>';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const n = state.slides.length;
        if (n < 2) return;
        go((state.index + (dir === 'prev' ? -1 : 1) + n) % n);
      });
      return button;
    });

    // Bir foto yuklenmeden ona gecilmez: o ana kadar onceki foto ekranda kalir (bosluk gorunmez)
    const ready = (i) => {
      const img = state.slides[i]?.firstChild;
      return !!(img && img.complete && img.naturalWidth > 0);
    };

    function fill(i) {
      const slide = state.slides[i];
      const img = slide && slide.firstChild;
      if (img && !img.getAttribute('src')) img.src = slide.dataset.src;
    }

    function paint(offset = 0) {
      [state.index - 1, state.index, state.index + 1, state.index + 2].forEach(fill);
      if (ready(state.index) || !ready(state.shown)) state.shown = state.index;
      link.style.setProperty('--juvelore-slide-offset', `calc(${-state.index * 100}% + ${offset}px)`);
      state.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === state.shown));
      [...indicator.children].forEach((item, i) => item.classList.toggle('is-active', i === state.index));
      link.toggleAttribute('data-jv-ready', ready(state.shown));
    }

    function go(index) {
      state.index = Math.max(0, Math.min(state.slides.length - 1, index));
      paint();
    }

    function makeImg(item, cover) {
      const img = item.node || document.createElement('img');
      img.removeAttribute('class');
      img.removeAttribute('fetchpriority');
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.removeAttribute('hidden');
      img.alt = '';
      img.draggable = false;
      img.decoding = 'async';
      if (cover) img.className = 'object-cover';
      img.addEventListener('load', () => paint());
      return img;
    }

    function build(items) {
      const primary = link.querySelector('.product-card__image--primary');
      const cover = !!primary?.classList.contains('object-cover');
      const current = state.slides[state.index]?.dataset.key;
      const old = new Map(state.slides.map((s) => [s.dataset.key, s]));
      track.textContent = '';
      state.slides = items.map((item) => {
        // Ayni foto zaten yuklendiyse onu koru (yeniden indirme ve bosluk olmasin)
        const prev = old.get(item.k);
        if (prev && prev.firstChild?.getAttribute('src')) {
          track.appendChild(prev);
          return prev;
        }
        const slide = document.createElement('span');
        slide.className = 'jv-card-slide';
        slide.dataset.key = item.k;
        slide.dataset.src = item.u;
        slide.appendChild(makeImg(item, cover));
        track.appendChild(slide);
        return slide;
      });
      indicator.innerHTML = state.slides.map(() => '<span></span>').join('');
      state.enabled = state.slides.length > 1;
      link.toggleAttribute('data-juvelore-swipe', state.enabled);
      link.toggleAttribute('data-jv-track', state.enabled);
      if (state.enabled && !track.isConnected) link.appendChild(track);
      if (state.enabled && !indicator.isConnected) link.after(indicator);
      if (state.enabled && !arrows[0].isConnected) figure.append(...arrows);
      track.hidden = indicator.hidden = !state.enabled;
      arrows.forEach((a) => (a.hidden = !state.enabled));
      const keep = state.slides.findIndex((s) => s.dataset.key === current);
      state.index = keep > 0 ? keep : 0;
      state.shown = state.index;
      paint();
    }

    // Kartin kendi fotograflarindan baslangic listesi (ana + ikinci foto); tema gorselinin kopyasi
    // kullanilir, boylece tarayici ayni boyuttaki onbellekteki dosyayi gosterir
    function fromCard() {
      const primary = link.querySelector('.product-card__image--primary');
      const secondary = link.querySelector('.product-card__image--secondary');
      const items = [];
      [primary, secondary].forEach((img) => {
        if (!img || img.hidden) return;
        const src = img.getAttribute('src');
        if (src && !items.some((i) => i.k === keyOf(src))) items.push({ k: keyOf(src), u: src, node: img.cloneNode(false) });
      });
      return items;
    }

    function load() {
      const handle = state.handle;
      if (!handle || state.loaded === handle) return;
      state.loaded = handle;
      const token = state.token;
      fetchList(handle).then((items) => {
        if (token !== state.token || items.length < 2) return;
        // Kartin ana fotografi listenin basinda degilse onu one al
        const primaryKey = keyOf(link.querySelector('.product-card__image--primary')?.src);
        const first = items.findIndex((i) => i.k === primaryKey);
        if (first > 0) items = [items[first], ...items.slice(0, first), ...items.slice(first + 1)];
        build(items);
      });
    }

    function reset() {
      state.token++;
      state.handle = handleOf(link.href);
      state.loaded = null;
      state.index = 0;
      state.gesture = null;
      state.slides = [];
      link.removeAttribute('data-juvelore-dragging');
      build(fromCard());
      if (mobile.matches) {
        if (near) near.observe(link); else load();
      }
    }
    state.load = load;

    // Masaustu: fare gelince tam listeyi al, 2. fotoya gec; cikinca ilk fotoya don
    figure.addEventListener('mouseenter', () => {
      if (!hover.matches) return;
      load();
      if (state.slides.length > 1) go(1);
      fill(2);
    });
    figure.addEventListener('mouseleave', () => {
      if (!hover.matches) return;
      go(0);
    });

    link.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') return;
      if (!mobile.matches || !state.enabled || !event.isPrimary || event.button !== 0) return;
      state.blockedUntil = 0;
      state.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, axis: null, moved: false };
    });
    link.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      const g = state.gesture;
      if (!g || event.pointerId !== g.id) return;
      const dx = event.clientX - g.x, dy = event.clientY - g.y;
      if (Math.max(Math.abs(dx), Math.abs(dy)) > 8) g.moved = true;
      if (!g.axis && g.moved) {
        g.axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
        if (g.axis === 'x') {
          link.setPointerCapture(event.pointerId);
          link.setAttribute('data-juvelore-dragging', '');
        }
      }
      if (g.axis !== 'x') return;
      g.dx = dx;
      paint(isEdge(dx) ? dx * .15 : dx);
    });
    function isEdge(dx) {
      return (state.index === 0 && dx > 0) || (state.index === state.slides.length - 1 && dx < 0);
    }
    function step(dx) {
      if (Math.abs(dx) > Math.min(48, link.clientWidth * .18)) state.index = Math.max(0, Math.min(state.slides.length - 1, state.index + (dx < 0 ? 1 : -1)));
    }
    function finish(event) {
      if (event.pointerType === 'touch') return;
      const g = state.gesture;
      if (!g || event.pointerId !== g.id) return;
      if (g.moved || event.type === 'pointercancel') state.blockedUntil = performance.now() + 700;
      if (event.type === 'pointerup' && g.axis === 'x') step(g.dx);
      state.gesture = null;
      link.removeAttribute('data-juvelore-dragging');
      if (link.hasPointerCapture(event.pointerId)) link.releasePointerCapture(event.pointerId);
      paint();
    }
    link.addEventListener('pointerup', finish);
    link.addEventListener('pointercancel', finish);
    link.addEventListener('lostpointercapture', finish);
    link.addEventListener('touchstart', (event) => {
      if (!mobile.matches || !state.enabled) return;
      load();
      if (event.touches.length !== 1) {
        state.gesture = null;
        state.blockedUntil = performance.now() + 700;
        link.removeAttribute('data-juvelore-dragging');
        paint();
        return;
      }
      const touch = event.touches[0];
      state.blockedUntil = 0;
      state.gesture = { id: touch.identifier, source: 'touch', x: touch.clientX, y: touch.clientY, dx: 0, axis: null, moved: false };
    }, { passive: true });
    link.addEventListener('touchmove', (event) => {
      const g = state.gesture;
      if (!g || g.source !== 'touch' || event.touches.length !== 1) return;
      const touch = [...event.touches].find(t => t.identifier === g.id);
      if (!touch) return;
      const dx = touch.clientX - g.x, dy = touch.clientY - g.y;
      if (!event.cancelable) {
        g.axis = 'y';
        g.moved = true;
        link.removeAttribute('data-juvelore-dragging');
        paint();
        return;
      }
      if (!g.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 4) {
        g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        g.moved = true;
      }
      if (g.axis === 'x' || (!g.axis && Math.abs(dx) > Math.abs(dy))) event.preventDefault();
      if (g.axis !== 'x') return;
      g.dx = dx;
      link.setAttribute('data-juvelore-dragging', '');
      paint(isEdge(dx) ? dx * .15 : dx);
    }, { passive: false, capture: true });
    function finishTouch(event) {
      const g = state.gesture;
      if (!g || g.source !== 'touch' || ![...event.changedTouches].some(t => t.identifier === g.id)) return;
      if (g.moved || event.type === 'touchcancel') state.blockedUntil = performance.now() + 700;
      if (event.type === 'touchend' && g.axis === 'x' && event.cancelable) event.preventDefault();
      if (event.type === 'touchend' && g.axis === 'x') step(g.dx);
      state.gesture = null;
      link.removeAttribute('data-juvelore-dragging');
      paint();
    }
    link.addEventListener('touchend', finishTouch, { passive: false });
    link.addEventListener('touchcancel', finishTouch, { passive: true });
    link.addEventListener('click', (event) => {
      if (event.detail !== 0 && performance.now() < state.blockedUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    // Renk secenegi (bagli urun) kartin fotograf/linkini degistirirse listeyi yeniden kur
    const watch = new MutationObserver((records) => {
      if (records.some((r) => r.target.classList?.contains('product-card__image') || r.target === link)) reset();
    });
    watch.observe(link, { subtree: true, attributes: true, attributeFilter: ['src', 'hidden', 'href'] });
    state.reset = reset;
    reset();
  }
  function scan(root) {
    if (root.matches?.('.product-card__media')) mount(root);
    root.querySelectorAll?.('.product-card__media').forEach(mount);
  }
  scan(document);
  new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
  }).observe(document.body, { childList: true, subtree: true });
  mobile.addEventListener('change', () => document.querySelectorAll(selector).forEach(link => states.get(link)?.reset()));
})();
